import { useState, useMemo } from "react";
import "./EmojiPicker.css";

const DEFAULT_EMOJIS = [
  "👍", "❤️", "😂", "😮", "😢", "🔥", "🎉", "💯",
  "👀", "🧠", "💪", "🤝", "✅", "⭐", "🚀", "💎",
  "👋", "🤔", "😍", "🥳", "😱", "🫡", "💯", "🎯",
  "💡", "🛠️", "⚡", "🌟", "📌", "🔗", "💬", "📢",
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onSelect, onClose }: EmojiPickerProps) {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search) return DEFAULT_EMOJIS;
    return DEFAULT_EMOJIS;
  }, [search]);

  return (
    <div className="emoji-picker" onBlur={onClose}>
      <div className="emoji-picker__search">
        <input
          className="emoji-picker__search-input"
          placeholder="Search emoji..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />
      </div>
      <div className="emoji-picker__grid">
        {filtered.map((emoji) => (
          <button
            key={emoji}
            className="emoji-picker__item"
            onClick={() => onSelect(emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="emoji-picker__empty">No emojis found</div>
      )}
    </div>
  );
}
